import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AiTranslateRepository } from "./ai-translate.repository";

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [],
  providers: [AiTranslateRepository],
})
export class AiTranslateDomainModule {}
